<agr-page-sidesheet
  [pageTitle]="'cropSettings' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'addCropSetting' | translate"
  (primaryAction)="addCropSetting()"
>
  <ng-container actions>
    @if (isMobile()) {
      <button mat-icon-button (click)="setSearch()" data-test="cropSetting-filter">
        <mat-icon>search</mat-icon>
      </button>
    }
  </ng-container>
  <ng-container sidesheet>
    <mat-toolbar class="mat-toolbar-transparent">
      <mat-icon>filter_list</mat-icon>
    </mat-toolbar>
    <div class="wrapper--spacing-horizontal">
      <mat-form-field class="full-width-field">
        <mat-label>{{ 'cropName' | translate }}</mat-label>
        <input
          id="crop-settings-filter-name"
          matInput
          [formControl]="filterNameControl"
          [placeholder]="'cropName' | translate"
          [attr.aria-label]="'cropName' | translate"
          data-test="cropSettings-filter-name"
        />
      </mat-form-field>
      <mat-form-field class="full-width-field">
        <mat-select
          [formControl]="filterYearControl"
          [placeholder]="'year' | translate"
          data-test="cropSettings-filter-year"
        >
          @for (year of availableCropYears; track year) {
            <mat-option [value]="year" data-test="overview-cropYear-options">
              {{ year }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div class="mat-button-row flex--justify-end">
        <button
          mat-button
          (click)="resetFilter()"
          [disabled]="filterEnabled() === false"
          data-test="filter-reset"
        >
          <mat-icon>clear</mat-icon> {{ 'resetFilter' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
  <agr-notification-empty
    [isEmpty]="!cropSettings().length || !filteredCropSettings().length"
    [emptyTitle]="'cropSettingsEmpty' | translate"
    [emptyDescription]="(filterEnabled() ? 'noCropSettingsFound' : 'noCropSetting') | translate"
    emptyActionIcon="clear"
    [emptyActionText]="'resetFilter' | translate"
    [showEmptyAction]="filterEnabled()"
    (emptyAction)="resetFilter()"
    class="notification-wrapper"
  >
    @if (cropSettings().length && pagedCropSettings().length) {
      <div class="container">
        <agr-table [config]="tableConfig" data-test="cropSettings-table"></agr-table>
        <mat-paginator
          [pageSize]="page().pageSize ?? pageSize"
          [pageSizeOptions]="[10, 25, 50]"
          [length]="filteredCropSettings().length"
          (page)="onPage($event)"
        ></mat-paginator>
      </div>
    }
  </agr-notification-empty>
</agr-page-sidesheet>
